var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M9.32 3.8c1.186-2.067 4.174-2.067 5.36 0l7.659 13.345c1.18 2.056-.315 4.605-2.68 4.605H4.341c-2.366 0-3.86-2.549-2.68-4.605L9.322 3.8ZM13 8.5a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5ZM12 16a1.2 1.2 0 0 0-.845.355 1.2 1.2 0 0 0-.355.845c0 .375.177.667.355.845A1.2 1.2 0 0 0 12 18.4a1.2 1.2 0 0 0 .845-.355 1.2 1.2 0 0 0 .355-.845 1.2 1.2 0 0 0-.355-.845A1.2 1.2 0 0 0 12 16Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export default ForwardRef;